import { render, staticRenderFns } from "./GroupRelatedList.vue?vue&type=template&id=282e21c6"
import script from "./GroupRelatedList.vue?vue&type=script&lang=js"
export * from "./GroupRelatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports